<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label for="">{{ $t("module.level") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="1"
            :max="levels.length"
            show-stops
          ></el-slider>
        </div>
        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>
      <a
        href="javascript:;"
        @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        "
        class="pause"
      >
        <i
          :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"
        ></i>
      </a>
      <a
        href="javascript:;"
        v-if="config == null || config == undefined"
        @click.stop="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>
      <h1
        v-if="counter > 0"
        style="
              color: #c78c6e;
    font-size: 46px;
    font-weight: bold;
    text-shadow: rgb(0 0 0) -1px 6px 10px;
}
        "
      >
        {{
          moment("2021-01-01 00:00:00")
            .add({ seconds: counter })
            .format("mm:ss")
        }}
      </h1>
      <h1
        style="
          color: white;
          font-size: 26px;
          font-weight: bold;
          text-shadow: -1px 6px 10px rgb(0 0 0 / 60%);
        "
      >
        {{ $t("module.which_bigger") }}
      </h1>

      <h1
        v-if="startCounter > 0"
        style="
          color: white;
          font-size: 56px;
          font-weight: bold;
          text-shadow: -1px 6px 10px rgb(0 0 0 / 60%);
        "
      >
        {{ startCounter }}
      </h1>

      <h1
        v-if="startCounter == 0 && counter == 0"
        style="
          color: white;
          font-size: 36px;
          font-weight: bold;
          text-shadow: -1px 6px 10px rgb(0 0 0 / 60%);
          text-align: center;
          margin-top: 52px;
        "
      >
        <p v-html="$t('module.timeisend', { point })"></p>
        <a
          href="javascript:;"
          @click="start"
          style="
            color: white;
            border-radius: 10px;
            border: 2px solid rgba(255, 255, 255, 0.5);
            font-size: 22px;
            padding: 10px 15px;
            margin-top: 30px;
            display: block;
          "
          >{{ $t("module.start_again") }}</a
        >
      </h1>

      <div
        v-if="counter > 0 && startCounter == 0"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0px 40px;
          width: 100%;
        "
      >
        <div
          v-for="(option, index) in options"
          style="
            background-color: white;
            border-radius: 15px;
            height: 250px;
            width: 250px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px;
            font-size: 67px;
            font-weight: bold;
          "
          :id="'option' + index"
          :style="{ color: colors[index] }"
        >
          {{ option.title }}
        </div>
      </div>
      <div v-if="counter > 0 && startCounter == 0">
        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: white;
            font-size: 19px;
          "
          @click="check({ keyCode: 37 })"
        >
          <span
            style="
              border: 1px solid #ddd;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-left"></i>
          </span>
          <span>{{ $t("module.left") }}</span>
        </a>
        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: white;
            font-size: 19px;
          "
          @click="check({ keyCode: 40 })"
        >
          <span
            style="
              border: 1px solid #ddd;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-down"></i>
          </span>
          <span>{{ $t("module.allsame") }}</span>
        </a>
        <a
          href="javascript:;"
          style="
            padding: 10px 15px;
            border-radius: 10px;
            color: white;
            font-size: 19px;
          "
          @click="check({ keyCode: 39 })"
        >
          <span
            style="
              border: 1px solid #ddd;
              width: 30px;
              display: inline-block;
              text-align: center;
              margin-right: 5px;
            "
          >
            <i class="fas fa-long-arrow-alt-right"></i>
          </span>
          <span>{{ $t("module.right") }}</span>
        </a>
      </div>
    </div>

    <div
      v-if="counter > 0"
      :style="{ width: wrapper.width + 'px' }"
      style="margin: 0 auto; border-radius: 0px; margin-top: 15px"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: row;
        "
      >
        <div style="display: flex; flex-direction: row">
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              style="
                position: relative;
                z-index: 9999;
                background-color: red;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: white;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 22px;
              "
            >
              <i class="fas fa-times"></i>
            </div>
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: red;
                height: 40px;
                padding-left: 20px;
                margin-left: -20px;
                z-index: 1;
                position: relative;
                line-height: 45px;
                padding-right: 10px;
              "
              >{{ totalFalse }}</span
            >
          </span>
          <span
            class="num"
            style="display: flex; align-items: center; justify-content: center"
          >
            <span
              style="
                font-size: 35px;
                font-weight: bold;
                color: white;
                background: rgb(28, 68, 156);
                height: 40px;
                padding-right: 20px;
                margin-right: -20px;
                z-index: 0;
                position: relative;
                line-height: 45px;
                padding-left: 10px;
              "
              >{{ totalTrue }}</span
            >
          </span>
          <svg
            height="40px"
            viewBox="0 0 512 512"
            width="40px"
            xmlns="http://www.w3.org/2000/svg"
            style="position: relative; z-index: 2"
          >
            <path
              d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0"
              fill="rgb(28, 68, 156)"
            />
            <path
              d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0"
              fill="#fafafa"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import axios from "axios";
export default {
  name: "GozEsnekligi",
  props: ["config", "getTime"],
  data() {
    return {
      pause: false,
      level: 5,
      levels: [[], [], [], [], []],
      autoLevel: 1,
      options: [],
      answerStack: [],
      totalTrue: 0,
      totalFalse: 0,
      counter: 0,
      settings: false,
      wrapper: {
        width: 0,
        height: 0,
      },
      moment,
      point: 0,
      startCounter: 5,
      colors: {
        0: null,
        1: null,
      },
      lock: false,
      reactions: [],
      lastPickTime: new Date().getTime(),
      points: [6, 8, 10, 12, 14],
      levelPoints: [
        {
          min: 0,
          max: 23,
          level: 1,
        },
        {
          min: 24,
          max: 55,
          level: 2,
        },
        {
          min: 56,
          max: 95,
          level: 3,
        },
        {
          min: 96,
          max: 143,
          level: 4,
        },
        {
          min: 144,
          max: 8888888,
          level: 5,
        },
      ],
    };
  },
  created() {
    this.$root.$emit("pause", true);
    for (let index = 0; index < 120; index++) {
      var n1 = _.random(1, 20);
      var n2 = _.random(Math.max(n1 - 9, 1), n1 + 9);
      this.levels[0].push([
        {
          title: n1,
          number: n1,
        },
        {
          title: n2,
          number: n2,
        },
      ]);
    }

    for (let index = 0; index < 120; index++) {
      var n1 = _.random(1, 20);
      var n2 = _.random(Math.max(n1 - 9, 1), n1 + 9);

      var isPlus = _.random(0, 1) == 1;
      var n = _.random(1, 9);

      if (
        this.$store.state.user.grade == "1" ||
        this.$store.state.user.grade == "2"
      ) {
        if (n1 - n <= 0 && isPlus) {
          n = 0;
        }
      }

      var title1 = isPlus ? n1 - n + "+" + n : n1 + n + "-" + n;

      this.levels[1].push(
        _.shuffle([
          {
            title: title1,
            number: n1,
          },
          {
            title: n2,
            number: n2,
          },
        ])
      );
    }

    for (let index = 0; index < 120; index++) {
      var n1 = _.random(1, 20);
      var n2 = _.random(Math.max(n1 - 9, 1), n1 + 9);

      var isPlus = _.random(0, 1) == 1;
      var n = _.random(1, 9);

      if (
        this.$store.state.user.grade == "1" ||
        this.$store.state.user.grade == "2"
      ) {
        if (n1 - n <= 0 && isPlus) {
          n = 0;
        }
      }

      var title1 = isPlus ? n1 - n + "+" + n : n1 + n + "-" + n;

      var isPlus = _.random(0, 1) == 1;
      var n = _.random(1, 9);

      if (
        this.$store.state.user.grade == "1" ||
        this.$store.state.user.grade == "2"
      ) {
        if (n1 - n <= 0 && isPlus) {
          n = 0;
        }
      }

      var title2 = isPlus ? n2 - n + "+" + n : n2 + n + "-" + n;

      this.levels[2].push(
        _.shuffle([
          {
            title: title1,
            number: n1,
          },
          {
            title: title2,
            number: n2,
          },
        ])
      );
    }

    if (
      this.$store.state.user.grade == "1" ||
      this.$store.state.user.grade == "2"
    ) {
      console.log("ok");

      for (let index = 0; index < 120; index++) {
        var n1 = _.random(1, 20);
        var n2 = _.random(Math.max(n1 - 9, 1), n1 + 9);

        var isPlus = _.random(0, 1) == 1;
        var n = _.random(1, 9);

        if (
          this.$store.state.user.grade == "1" ||
          this.$store.state.user.grade == "2"
        ) {
          if (n1 - n <= 0 && isPlus) {
            n = 0;
          }
        }

        var title1 = isPlus ? n1 - n + "+" + n : n1 + n + "-" + n;

        var isPlus = _.random(0, 1) == 1;
        var n = _.random(1, 9);

        if (
          this.$store.state.user.grade == "1" ||
          this.$store.state.user.grade == "2"
        ) {
          if (n1 - n <= 0 && isPlus) {
            n = 0;
          }
        }

        var title2 = isPlus ? n2 - n + "+" + n : n2 + n + "-" + n;

        this.levels[3].push(
          _.shuffle([
            {
              title: title1,
              number: n1,
            },
            {
              title: title2,
              number: n2,
            },
          ])
        );
      }

      for (let index = 0; index < 120; index++) {
        var n1 = _.random(1, 20);
        var n2 = _.random(Math.max(n1 - 9, 1), n1 + 9);

        var isPlus = _.random(0, 1) == 1;
        var n = _.random(1, 9);

        if (
          this.$store.state.user.grade == "1" ||
          this.$store.state.user.grade == "2"
        ) {
          if (n1 - n <= 0 && isPlus) {
            n = 0;
          }
        }

        var title1 = isPlus ? n1 - n + "+" + n : n1 + n + "-" + n;

        var isPlus = _.random(0, 1) == 1;
        var n = _.random(1, 9);

        if (
          this.$store.state.user.grade == "1" ||
          this.$store.state.user.grade == "2"
        ) {
          if (n1 - n <= 0 && isPlus) {
            n = 0;
          }
        }

        var title2 = isPlus ? n2 - n + "+" + n : n2 + n + "-" + n;

        this.levels[4].push(
          _.shuffle([
            {
              title: title1,
              number: n1,
            },
            {
              title: title2,
              number: n2,
            },
          ])
        );
      }
    } else {
      for (let index = 0; index < 150; index++) {
        var bolme = _.random(0, 1) == 1;

        if (bolme == 0) {
          // bolme
          var n1 = _.random(10, 99); // 25

          while (true) {
            if (
              "11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97"
                .split(",")
                .map((k) => parseInt(k.trim()))
                .indexOf(n1) != -1
            )
              n1 = _.random(10, 99);
            else break;
          }

          var n = _.random(2, 9); // 5

          while (true) {
            if (n1 % n != 0) {
              n = _.random(2, 9);
            } else {
              break;
            }
          }

          var n2 = Math.max(n1 / n + _.random(1, 3), 2); // 8

          var title1 = n1 + "÷" + n;

          n1 = n1 / n; // 5
        } else {
          // carpma
          var n1 = _.random(2, 9);
          var n = _.random(2, 9);

          var n2 = n1 * n + _.random(1, 3);

          var title1 = n1 + "x" + n;
          n1 = n1 * n;
        }

        this.levels[3].push(
          _.shuffle([
            {
              title: title1,
              number: n1,
            },
            {
              title: n2,
              number: n2,
            },
          ])
        );
      }

      for (let index = 0; index < 150; index++) {
        var bolme = _.random(0, 1) == 1;

        if (bolme == 0) {
          // bolme
          var n3 = _.random(10, 99); // 25

          while (true) {
            if (
              "11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97"
                .split(",")
                .map((k) => parseInt(k.trim()))
                .indexOf(n3) != -1
            )
              n3 = _.random(10, 99);
            else break;
          }

          var n4 = _.random(2, 9); // 5

          while (true) {
            if (n3 % n4 != 0) {
              n4 = _.random(2, 9);
            } else {
              break;
            }
          }

          var n1 = n3 / n4;

          var title1 = n3 + "÷" + n4;

          n1 = n3 / n4; // 5
        } else {
          // carpma
          var n3 = _.random(2, 9);
          var n4 = _.random(2, 9);

          var title1 = n3 + "x" + n4;

          var n1 = n3 * n4;
        }

        // n2
        var bolme = _.random(0, 1) == 1;

        if (bolme == 0) {
          // bolme
          var n5 = _.random(10, 99); // 25

          while (true) {
            if (
              "11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97"
                .split(",")
                .map((k) => parseInt(k.trim()))
                .indexOf(n5) != -1
            )
              n5 = _.random(10, 99);
            else break;
          }

          var n6 = _.random(2, 9); // 5

          while (true) {
            if (n5 % n6 != 0) {
              n6 = _.random(2, 9);
            } else {
              break;
            }
          }

          var n2 = n5 / n6;

          var title2 = n5 + "÷" + n6;

          n2 = n5 / n6; // 5
        } else {
          // carpma
          var n5 = _.random(2, 9);
          var n6 = _.random(2, 9);

          var title2 = n5 + "x" + n6;

          var n2 = n5 * n6;
        }

        while (true) {
          if (n2 > n1 + 5 || n2 < n1 - 5) {
            bolme = _.random(0, 1) == 1;

            if (bolme == 0) {
              // bolme
              n5 = _.random(10, 99); // 25

              while (true) {
                if (
                  "11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97"
                    .split(",")
                    .map((k) => parseInt(k.trim()))
                    .indexOf(n5) != -1
                )
                  n5 = _.random(10, 99);
                else break;
              }

              n6 = _.random(2, 9); // 5

              while (true) {
                if (n5 % n6 != 0) {
                  n6 = _.random(2, 9);
                } else {
                  break;
                }
              }

              n2 = n5 / n6;

              title2 = n5 + "÷" + n6;

              n2 = n5 / n6; // 5
            } else {
              // carpma
              n5 = _.random(2, 9);
              n6 = _.random(2, 9);

              title2 = n5 + "x" + n6;

              n2 = n5 * n6;
            }
          } else {
            break;
          }
        }

        this.levels[4].push(
          _.shuffle([
            {
              title: title1,
              number: n1,
            },
            {
              title: title2,
              number: n2,
            },
          ])
        );
      }
    }

    if (this.config != null && this.config != undefined) {
      //this.level = this.config.level;
      //this.autoLevel = this.config.auto_level;
    }
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
    this.start();
    window.addEventListener("keydown", this.check);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.startInterval);
    window.removeEventListener("keydown", this.check);
  },
  methods: {
    start() {
      if (this.config != null && this.config != undefined) {
        if (this.config.getTime() < 60) {
          this.$root.$emit("done");
          return;
        }
      }
      this.counter = 0;
      this.point = 0;
      this.totalFalse = 0;
      this.totalTrue = 0;
      this.level = 1;
      this.startCounter = 5;
      this.options =
        this.levels[this.level - 1][
          _.random(0, this.levels[this.level - 1].length - 1)
        ];

      this.startInterval = setInterval(() => {
        if (this.pause) return;
        this.startCounter -= 1;
        if (this.startCounter == 0) {
          setTimeout(() => {
            this.$root.$emit("pause", false);
          }, 2000);
          clearInterval(this.startInterval);
          this.counter = 60;
          this.lastPickTime = new Date().getTime();
          this.interval = setInterval(() => {
            if (this.pause) return;
            this.counter -= 1;
            if (this.counter == 0) {
              axios.post("module/savePoints", {
                points: [
                  {
                    point: this.point,
                    type: "dikkat",
                  },
                ],
                module_id: this.$store.state.modules.find(
                  (k) => k.slug == "hangisi-buyuk"
                ).module_id,
              });

              axios.post("module/savePoints", {
                points: [
                  {
                    point: this.point,
                    type: "matematik",
                  },
                ],
                module_id: this.$store.state.modules.find(
                  (k) => k.slug == "hangisi-buyuk"
                ).module_id,
              });

              axios
                .post("module/savePoints", {
                  points: [
                    {
                      point:
                        this.reactions.reduce(
                          (counter, item) => (item += counter),
                          0
                        ) / this.reactions.length,
                      type: "tepki",
                    },
                  ],
                  module_id: this.$store.state.modules.find(
                    (k) => k.slug == "hangisi-buyuk"
                  ).module_id,
                })
                .then((res) => {
                  this.reactions = [];
                });

              clearInterval(this.interval);
            }
          }, 1000);
        }
      }, 1000);
    },
    warning(answer) {
      if (this.pause) return;
      this.lock = true;
      if (answer == "left") {
        if (this.options[0].number > this.options[1].number) {
          this.colors[0] = "green";
        }
        if (this.options[0].number < this.options[1].number) {
          this.colors[1] = "green";
          this.colors[0] = "red";
        }
        if (this.options[0].number == this.options[1].number) {
          this.colors[1] = "orange";
          this.colors[0] = "orange";
        }
      }
      if (answer == "right") {
        if (this.options[0].number > this.options[1].number) {
          this.colors[0] = "green";
          this.colors[1] = "red";
        }
        if (this.options[0].number < this.options[1].number) {
          this.colors[1] = "green";
        }
        if (this.options[0].number == this.options[1].number) {
          this.colors[1] = "orange";
          this.colors[0] = "orange";
        }
      }
      if (answer == "down") {
        if (this.options[0].number > this.options[1].number) {
          this.colors[1] = "orange";
          this.colors[0] = "orange";
        }
        if (this.options[0].number < this.options[1].number) {
          this.colors[1] = "orange";
          this.colors[0] = "orange";
        }
        if (this.options[0].number == this.options[1].number) {
          this.colors[1] = "green";
          this.colors[0] = "green";
        }
      }

      setTimeout(() => {
        this.next();
      }, 900);
    },
    check(e) {
      if (this.counter == 0 || this.lock == true || this.pause == true) return;
      const keyCode = parseInt(e.keyCode || e.code || e.keyIdentifier);
      switch (keyCode) {
        case 40:
          this.warning("down");
          if (this.options[0].number == this.options[1].number) {
            this.totalTrue += 1;

            this.point += this.points[this.level - 1];
            this.answerStack.push(true);
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            this.point -= 5;
            this.answerStack.push(false);
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          break;

        case 37:
          this.warning("left");
          if (this.options[0].number > this.options[1].number) {
            this.totalTrue += 1;
            this.answerStack.push(true);
            this.point += this.points[this.level - 1];
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            this.point -= 5;
            this.answerStack.push(false);
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          break;

        case 39:
          this.warning("right");
          if (this.options[0].number < this.options[1].number) {
            this.totalTrue += 1;
            this.answerStack.push(true);
            this.point += this.points[this.level - 1];
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/correct.mp3").play();
            this.reactions.push(new Date().getTime() - this.lastPickTime);
            this.lastPickTime = new Date().getTime();
          } else {
            this.totalFalse += 1;
            this.point -= 5;
            this.answerStack.push(false);
            if (this.$store.state.selectedTick2 != "sessiz")
              new Audio("/static/incorrect.mp3").play();
          }

          break;

        default:
          break;
      }
    },
    next() {
      this.colors = {
        0: null,
        1: null,
      };
      this.options =
        this.levels[this.level - 1][
          _.random(0, this.levels[this.level - 1].length - 1)
        ];
      setTimeout(() => {
        this.lock = false;
      }, 400);
    },
  },
  watch: {
    totalTrue: function () {
      this.answerStack.push(true);
      if (this.answerStack.length == 6) {
        this.answerStack.splice(0, 1);
      }
    },
    totalFalse: function () {
      this.answerStack.push(false);
      if (this.answerStack.length == 6) {
        this.answerStack.splice(0, 1);
      }
    },
    answerStack: {
      handler: function () {
        this.level = this.levelPoints.find(
          (k) => k.min <= this.point && k.max > this.point
        ).level;

        /*
        if (this.answerStack.filter((k) => k == true).length == 3) {
          this.answerStack = this.answerStack.filter((k) => k == false);
          this.level = Math.min(this.level + 1, this.levels.length);
        }

        if (this.answerStack.filter((k) => k == false).length == 3) {
          this.answerStack = this.answerStack.filter((k) => k == true);
          this.counter = Math.max(this.counter - 5, 1);
          this.level = Math.max(this.level - 1, 1);
        }
        */
      },
      deep: true,
    },
    counter: function (newValue, oldValue) {
      if (
        (newValue < oldValue && oldValue - newValue == 5) ||
        oldValue - newValue == 2 ||
        oldValue - newValue == 7
      ) {
        console.log(oldValue - newValue);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url("/static/img/school-blackboard.jpg") !important;
  flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/HangisiBuyuk.vue